import { EVENT_CATEGORIES, EVENT_TYPES } from '../constants';
import type { IInitialEvent } from '../types';

// Выдача

const EVENT_CATEGORY = EVENT_CATEGORIES.CREDITS;
const EVENT_TYPE = EVENT_TYPES.MAIN_EVENT;

export interface IOfferParams {
  id: string;
  sum: string;
  term: string;
  rate: string;
  psk: string;
}

export const eventShowOffers = (): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Просмотр экрана|Просмотр предложений',
  eventLabel: 'Приоритет - Подбор|Вкладка Подбор',
  eventValue: undefined,
});

export const eventEmptyOffers = (isErrorResponse: boolean, calcId?: string): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Ничего не найдено',
  eventLabel: isErrorResponse ? 'Ошибка запроса' : `${calcId}|Пустая выдача`,
  eventValue: undefined,
});

export const eventChangeFilter = (label: string): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Выбор фильтра',
  eventLabel: label,
  eventValue: undefined,
});

export const eventGoToOfferWebsite = (params: IOfferParams): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Отправить заявку',
  eventLabel: `Банк' - ${params.id} | 'Сумма' - ${params.sum} | 'Срок' - ${params.term} | 'Ставка' - ${params.rate} | 'ПСК' - ${params.psk}`,
  eventValue: undefined,
});
